// ÜRES SZEKCIÓ jelzése egy detail-/form-oldalon: szaggatott keretű, egysoros doboz — bal oldalt a szekció
// ikonja, mellette EGY mondat arról, mi hiányzik (vagy miért nem kezelhető még).
//
// MIÉRT EGY KOMPONENS a zárolt és az üres esetre: a felhasználó szemszögéből ez ugyanaz a pillanat — „ebben a
// szekcióban most nincs adat". Létrehozáskor MÉG nem lehet (zárolt), szerkesztéskor MÉG nincs (üres). Ha a két
// állapot két külön vizuális nyelvet beszélne (ott szaggatott doboz ikonnal, itt egy sor halvány szöveg), az
// oldal két különböző terméknek látszana ugyanarra az információra. Egy alak, egy jelentés.
//
// A LAKAT KÜLÖNBSÉGET JELENT, nem díszít: a zárolt esetben van egy feltétel, amit teljesíteni kell (mentsd el az
// ügyfelet), az üresben nincs — ott a szekció fejlécének „hozzáadás" gombja az azonnali kiút. Ezért a lakat
// KIZÁRÓLAG a zárolt ágon jelenik meg; üres szekcióra téve azt hazudná, hogy tiltva van valami.
//
// KOMPAKT (nem `EmptyState`): négy-öt szekció egymás alatt, mindegyik nagy, középre zárt üres-állapottal
// aránytalanul hosszúra nyújtaná az oldalt, és elnyomná a lényeget — a tényleges űrlapot.
import { LockClosedIcon } from '@heroicons/react/24/outline';
import type { ComponentType, ReactNode, SVGProps } from 'react';

export type SectionIcon = ComponentType<SVGProps<SVGSVGElement>>;

export function SectionPlaceholder({
  icon: Icon,
  /** Zárolt szekció: a lakat + `aria-disabled` csak ekkor kerül ki. */
  locked = false,
  children,
}: {
  icon: SectionIcon;
  locked?: boolean;
  children: ReactNode;
}): JSX.Element {
  return (
    <div
      // `aria-disabled` + a dekoratív ikonok `aria-hidden`-je: a képernyőolvasó a szövegből érti meg az
      // állapotot, nem az ikonok felolvasásából.
      {...(locked ? { 'aria-disabled': 'true' as const } : {})}
      className="text-muted-foreground flex items-center gap-3 rounded-lg border border-dashed px-4 py-3.5 text-sm"
    >
      <span className="bg-sunken inline-flex size-8 shrink-0 items-center justify-center rounded-lg border">
        <Icon className="size-4" aria-hidden="true" />
      </span>
      <span className="flex-1">{children}</span>
      {locked && <LockClosedIcon className="size-4 shrink-0 opacity-60" aria-hidden="true" />}
    </div>
  );
}
